import { gql } from "@apollo/client";

const Projects = gql`
  query Projects {
    allProjects(orderBy: PROJECT_NAME_ASC) {
      nodes {
        id
        projectName
        isActive
        uploadCount: uploadsByProjectName {
          count: totalCount
        }
        photos: photosByProjectName {
          count: totalCount
        }
        addedOn
      }
    }
  }
`;

const hash = "72a507a3a5e4b9760a59f3dfac934cf460eaad095bee3037490645f257056e04";

export { Projects, hash };
